import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
      maxWidth: '100%',
      marginTop: theme.spacing(2),
    },
    media: {
      height: 140,
    },
    logo: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1.75)
      },
      logoImg: {
        objectFit: 'contain',
        maxHeight: theme.spacing(4),
        maxWidth: theme.spacing(20),
     },
     AlertMessage: {
        "& .MuiAlert-message": {
          fontSize: 14
        }
      }
     
  }));

export default useStyles;